<template>
  <section
    id="device-dashboard"
    style="width: 100vw;
            padding: 0px !important;
            margin: 0px !important;
            left: 0px !important;
            position: absolute;
z-index: 9;"
  >
    <div class="panel-car">
      <b-card-body style="height: 100%; padding-top: 0;color: #fff;font-size: 0.7rem;overflow-x: hidden;">
        <b-row style="background: #005c4d;color: #fff;margin-top: 10px;">
          <b-col
            cols="9"
            style="text-align: right; padding-right: 24px;display: inherit;"
          >
            <span style="font-size: 1.1rem;">{{ getDeviceInfo(selectedDevice).title }}</span>
            <v-divider
              style="background: rgb(142, 193, 174) none repeat scroll 0% 0%;"
              class="mx-1"
              vertical
            />
            <span style="font-size: 0.8rem;line-height: 1.6rem;">
              <v-icon
                size="15"
                color="#fff"
              >mdi-clock-outline</v-icon> {{ sinceFrom(getLastAlarm(selectedDevice)) }}</span>
          </b-col>
          <b-col
            cols="0"
            class="pr-0"
          />
          <b-col
            cols="3"
            class="pl-0 pr-1 pt-1 pb-0"
            style="text-align: left;"
          >
            <span style="font-size: 0.6rem;position: absolute;left: 15px;top: 5px;">GSM</span>
            <span style="font-size: 0.7rem;">{{ getDeviceInfo(selectedDevice).serverStatus.gsmSigStrength }}</span>
            <span style="">
              <v-icon
                size="21"
                color="#fff"
              >mdi-signal</v-icon> </span>

          </b-col>
        </b-row>
        <b-row style="padding: 10px 10px;align-content: center;height: 15vh;">
          <b-col cols="7">
            <span
              v-if="getDeviceOnlineStatusCssClass(getDeviceInfo(selectedDevice).imei)!=='onlineSymbol'"
              style="background: rgb(159, 155, 155);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
            >{{ $t('Inactive') }}</span>
            <span
              v-else-if="getDeviceInfo(selectedDevice).serverStatus.terminalInfo.ignition"
              style="background: #28c76a;padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/"
            >{{ $t('On') }}</span>

            <span
              v-else
              style="background: rgb(199, 40, 40);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/"
            >
              {{ $t('Off') }}
            </span>
          </b-col>
          <b-col cols="5">
            <img
              class="imgcartop"
              src="@/assets/images/icons/car-dash.png"
            >
          </b-col>
          <b-col
            cols="12"
            style="padding-top: 0;"
          ><span
             v-if="address===null"
             style="color: rgb(53, 151, 239);border-bottom: 1px solid;cursor: pointer;"
             @click="getAddress"
           >{{ $t('Show address') }}</span>
            <span
              v-else-if="address==='loading'"
              style="color: #999;"
            >{{ $t('Getting address') }}...</span>
            <span
              v-else-if="address==='error'"
              style="color: #c00;"
            >{{ $t('Address error') }}
              <span
                style="color: rgb(53, 151, 239);border-bottom: 1px solid;cursor: pointer;margin-right: 5px;"
                @click="getAddress"
              >{{ $t('Retry') }}</span>
            </span>
            <span v-else>{{ address }}</span>
          </b-col>
        </b-row>
        <b-col cols="12">
          <v-divider style="background: #aaa;margin-top: 0;" />
        </b-col>
        <b-row style="height: 10vh;">
          <b-col
            cols="4"
            style="padding-top: 0px;"
          >
            <div style="text-align: center;">
              <span><v-icon
                size="18"
                color="#28c76a"
              >mdi-crosshairs-gps</v-icon> {{ $t('Tracing status') }}</span>
            </div>
            <div style="text-align: center;line-height: 2rem;margin-top: 12px;">
              <span
                v-if="getDeviceOnlineStatusCssClass(getDeviceInfo(selectedDevice).imei)==='onlineSymbol'"
                style="background: #28c76a;padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
              >{{ $t('Online') }}</span>
              <span
                v-else
                style="background: rgb(199, 40, 40);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
              >{{ $t('Offline') }}</span>
            </div>
          </b-col>
          <v-divider
            vertical
            style="background: #eee;"
          />
          <b-col
            cols="4"
            style="padding-top: 0px;"
          >
            <div style="text-align: center;">
              <span><v-icon
                size="18"
                color="#28c76a"
              >mdi-speedometer</v-icon> {{ $t('Speed') }}</span>
            </div>
            <div style="text-align: center;line-height: 2rem;margin-top: 12px;">
              <span
                v-if="getDeviceOnlineStatusCssClass(getDeviceInfo(selectedDevice).imei)!=='onlineSymbol'"
                style="background: rgb(159, 155, 155);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
              >{{ $t('Inactive') }}</span>
              <span v-else-if="getDeviceInfo(selectedDevice).serverInfo.speed !== 0">
                {{ getDeviceInfo(selectedDevice).serverInfo.speed + 'Km/H' }}
              </span>
              <span
                v-else
                style="background: rgb(199, 159, 40);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
              >
                {{ $t('Stop') }}</span>

            </div>
          </b-col>
          <v-divider
            vertical
            style="background: #eee;"
          />
          <b-col
            cols="4"
            style="padding-top: 0px;"
          >
            <div style="text-align: center;">
              <span><v-icon
                size="18"
                color="#28c76a"
              >mdi-car-battery</v-icon> {{ $t('Battery status') }}</span>
            </div>
            <div
              style="text-align: center;line-height: 2rem;margin-top: 12px;"
            >
              <span
                v-if="getDeviceOnlineStatusCssClass(getDeviceInfo(selectedDevice).imei)!=='onlineSymbol'"
                style="background: rgb(159, 155, 155);padding: 3px 8px;border-radius: 10px;/*border: 1px solid #fff;*/font-size: 0.8rem;"
              >{{ $t('Inactive') }}</span>
              <span v-else-if="getDeviceInfo(selectedDevice).serverStatus.terminalInfo.charging">
                {{ getDeviceInfo(selectedDevice).serverStatus.voltageLevel }}
              </span>
              <span v-else>{{ $t('Plugged out desc') }}</span>

            </div>
          </b-col>
        </b-row>

        <b-row style="background: #005c4d;color: #fff;margin-top: 4vh;">
          <b-col
            cols="12"
            style="text-align: center;padding-top: 1vh;padding-bottom: 1vh;"
          >
            <span style="font-size: 1rem;">{{ $t('Commands and alarms') }}</span>
          </b-col>
        </b-row>
        <b-row
          class="pb-0"
          style="align-content: center;height: 30vh;margin-top: 5vh;"
        >
          <b-col
            cols="4"
            class="pr-0 pl-3"
            style="padding-top: 5vh;"
          >
            <div style="display: inline-flex;width: max-content;margin-bottom: 2vh;">
              <span style="padding-left: 10px;">{{ $t('Start alarm') }}</span>
              <b-form-checkbox
                v-model="notificationSettings.ignition"
                name="check-button"
                switch
                size="sm"
                style="vertical-align: top;padding-left: 5px;"
                @change="onSetNotificationSettings()"
              />
            </div>
            <div style="display: inline-flex;width: max-content;margin-bottom: 2vh;">
              <span style="padding-left: 10px;">{{ $t('Battery alarm') }}</span>
              <b-form-checkbox
                v-model="notificationSettings.charging"
                name="check-button"
                switch
                size="sm"
                style="vertical-align: top;padding-right: 35px;"
                @change="onSetNotificationSettings()"
              />
            </div>
            <v-divider style="background: #eee;" />
            <div style="text-align: center;">
              <b-button
                style="background: #28c76a !important;border-radius: 10px;border: 1px solid #fff !important;padding: 5px;"
                class="btn btn-light btn-sm"
                :disabled="powerBtnDisabled(getDeviceInfo(selectedDevice).imei, 'powerOn')"
                @click="onSendCommand(getDeviceInfo(selectedDevice).imei, 'powerOn')"
              >
                <v-icon
                  size="30"
                  color="#fff"
                >mdi-power-plug</v-icon><br>
                <span style="">{{ $t('Plugged in') }}</span>
              </b-button>
            </div>
          </b-col>
          <b-col
            cols="4"
            class="pr-0 pl-0"
            style="text-align: center;padding-top: 6vh;"
          ><img
            class="imgcar"
            src="@/assets/images/icons/car-dash2.png"
          >
          </b-col>
          <b-col
            cols="4"
            class="pl-0"
            style="padding-top: 5vh;"
          >
            <div style="display: inline-flex;width: 100%;margin-bottom: 2vh;">
              <b-form-checkbox
                v-model="notificationSettings.switchSpeed"
                name="check-button"
                switch
                size="sm"
                style="vertical-align: top;"
                @change="onSetNotificationSettings()"
              />
              <span style="margin-right: -50px;">{{ $t('Speed alarm') }}</span>
            </div>
            <div style="display: inline-flex;width: max-content;margin-bottom: 2vh;">
              <b-form-checkbox
                v-model="notificationSettings.gpsTracking"
                name="check-button"
                switch
                size="sm"
                style="vertical-align: top;padding-left: 5px;"
                @change="onSetNotificationSettings()"
              />
              <span style="margin-right: -50px;">{{ $t('Crane handling alarm') }}</span>
            </div>

            <v-divider style="background: #eee;" />
            <div style="text-align: center;">
              <b-button
                style="background: #c72828 !important;border-radius: 10px;border: 1px solid #fff !important;padding: 5px;"
                class="btn btn-light btn-sm"
                :disabled="powerBtnDisabled(getDeviceInfo(selectedDevice).imei, 'powerOff')"
                @click="onSendCommand(getDeviceInfo(selectedDevice).imei, 'powerOff')"
              >
                <v-icon
                  size="30"
                  color="#fff"
                >mdi-power-plug-off</v-icon><br>
                <span style="">{{ $t('Plugged out') }}</span>
              </b-button>
            </div>
          </b-col>

        </b-row>

        <b-row class="px-1">
          <b-col cols="12">
            <power-command-status
              :imei="getDeviceInfo(selectedDevice).imei"
              :state="powerCmd"
              :relay="relayInfo(getDeviceInfo(selectedDevice).imei)"
              :elapsed="powerCmdElapsed()"
              dark
              @dismiss="dismissPowerCmd"
            />
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col
            cols="4"
            class="pr-0"
          >
            <b-button
              style="width: 100%;background: #ccc0 !important;font-size: 0.8rem;"
              class="btn btn-light btn-sm pr-0 pl-0"
              @click="onSendSMS('CENTER')"
            >
              <v-icon
                size="20"
                color="#fff"
              >mdi-account-tie</v-icon>
              <span style="">{{ $t('Manager number') }}</span>
            </b-button>
          </b-col>
          <b-col
            cols="4"
            style="padding-left: 2px !important;padding-right: 2px !important;"
          />
          <b-col
            cols="4"
            class="pl-0"
          >
            <b-button
              style="width: 100%;background: #ccc0 !important;font-size: 0.8rem;"
              class="btn btn-light btn-sm pr-0 pl-0"
              @click="onSendSMS('SOS')"
            >
              <v-icon
                size="20"
                color="#fff"
              >mdi-car-brake-alert</v-icon>
              <span style=""> SOS</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-0 mb-2">
          <b-col
            cols="4"
            class="pr-0"
          >

            <b-button
              style="width: 100%;background: #ccc0 !important;font-size: 0.8rem;"
              class="btn btn-light btn-sm pr-0 pl-0"
              @click="onSendSMS('SPEED')"
            >
              <v-icon
                size="20"
                color="#fff"
              >mdi-account-tie</v-icon>
              <span style="">{{ $t('Unauthorized speed') }}</span>
            </b-button>
          </b-col>
          <b-col
            cols="4"
            style="padding-left: 2px !important;padding-right: 2px !important;"
          >

            <b-button
              style="width: 100%;background: #ccc0 !important;font-size: 0.8rem;"
              class="btn btn-light btn-sm pr-0 pl-0"
              @click="onSendSMS('RESET')"
            >
              <v-icon
                size="20"
                color="#fff"
              >mdi-restart</v-icon>
              <span style="">{{ $t('Restart') }}</span>
            </b-button>
          </b-col>
          <b-col
            cols="4"
            class="pl-0"
          >
            <b-button
              style="width: 100%;background: #ccc0 !important;font-size: 0.8rem;"
              class="btn btn-light btn-sm pr-0 pl-0"
              @click="onSendSMS('PARAM')"
            >
              <v-icon
                size="20"
                color="#fff"
              >mdi-table</v-icon>
              <span style="">{{ $t('Parameters') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </div>

    <b-modal
      ref="modal-center"
      cancel-variant="outline-secondary"
      :ok-title="$t('Save')"
      :cancel-title="$t('Close')"
      centered
      title="تنظیمات شماره مدیر"
    >
      <p>این شماره قابلیت خاموش و روشن کردن خودرو را دارد.<br>
        این دستور حتما توسط یکی از شماره های اضطراری باید ارسال شود.</p>
      <b-form-group
        label="شماره همراه"
        label-for="v-Sim"
      >
        <b-form-input
          v-model="phone"
          style="text-align: left;"
        />
      </b-form-group>
      <div style="text-align: left;">
        <code>CENTER,A,{{ phone }}#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'CENTER,A,'+phone+'#')/*SendSms('CENTER,A,'+phone+'#')*/"
      >
        ارسال
      </b-button>
      <hr>
      <p>حذف شماره مدیر</p>
      <div style="text-align: left;">
        <code>CENTER,D#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'CENTER,D#')/*SendSms('CENTER,D,#')*/"
      >
        ارسال
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-center ')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-sosNumber"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="شماره های اضطراری"
    >
      <p>این شماره ها قابلیت شنود دارند و کلیه هشدارها از طرف ردیاب به این شماره ها ارسال می شود.</p>
      <b-form-group
        label="شماره اول"
        label-for="v-phone"
      >
        <b-form-input
          v-model="phone"
          style="text-align: left;"
        />
      </b-form-group>
      <b-form-group
        label="شماره دوم"
        label-for="v-phone2"
      >
        <b-form-input
          v-model="phone2"
          style="text-align: left;"
        />
      </b-form-group>
      <b-form-group
        label="شماره سوم"
        label-for="v-phone3"
      >
        <b-form-input
          v-model="phone3"
          style="text-align: left;"
        />
      </b-form-group>
      <div style="text-align: left;direction: ltr;">
        <code>SOS,A,{{ phone+','+phone2+','+phone3 }}#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'SOS,A,'+phone+','+phone2+','+phone3+'#')/*SendSms('SOS,D,#')*/"
      >
        ارسال
      </b-button>
      <hr>
      <p>حذف شماره های اضطراری.</p>
      <b-form-group
        label="شماره اول"
        label-for="v-phone"
      >
        <b-form-input
          v-model="phone"
          style="text-align: left;"
        />
      </b-form-group>
      <b-form-group
        label="شماره دوم"
        label-for="v-phone2"
      >
        <b-form-input
          v-model="phone2"
          style="text-align: left;"
        />
      </b-form-group>
      <b-form-group
        label="شماره سوم"
        label-for="v-phone3"
      >
        <b-form-input
          v-model="phone3"
          style="text-align: left;"
        />
      </b-form-group>
      <div style="text-align: left;direction: ltr;">
        <code>SOS,D,{{ phone4 }}#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'SOS,D,'+phone+','+phone2+','+phone3+'#')/*SendSms('SOS,D,#')*/"
      >
        ارسال پیامک
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-sosNumber')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-speed"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="تنظیم سرعت غیر مجاز"
    >
      <p>باتنظيم عملكردزیر،اگر خودرو از سرعت مجاز عبوركند دستگاه
        سرعت خودرو را به شما هشدار ميدهد.<br>

      </p>
      <b-form-group
        label="زمان"
        label-for="v-second"
      >
        <b-form-input
          v-model="second"
          style="text-align: left;"
        />
      </b-form-group>
      <b-form-group
        label="سرعت"
        label-for="v-speed"
      >
        <b-form-input
          v-model="speed"
          style="text-align: left;"
        />
      </b-form-group>
      <div style="text-align: left;">
        <code>SPEED,ON,{{ second }},{{ speed }},1#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'SPEED,ON,'+second+','+speed+',1#')/*SendSms('SPEED,ON,'+limitspeedtime+','+limitspeed+',1#')*/"
      >
        ارسال
      </b-button>

      <br>
      <b-button
        variant="gradient-primary"
        class="btn-sm"
        @click="onSendCommand(selectedDevice, 'SPEED,OFF#')/*SendSms('SPEED,OFF#')*/"
      >
        <span style="">خاموش کردن هشدار سرعت</span>
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-speed')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>
    <b-modal
      ref="modal-reset"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="ریست کردن دستگاه"
    >
      <p />
      <div style="text-align: left;">
        <code>RESET#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="onSendCommand(selectedDevice, 'RESET#')/*SendSms('RESET#')*/"
      >
        ارسال
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-reset')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>
    <b-modal
      ref="modal-param"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="مشاهده اطلاعات دستگاه"
    >
      <p />
      <div style="text-align: left;">
        <code>PARAM#</code>
      </div>
      <b-button
        size="sm"
        variant="success"
        @click="modalSendSms('PARAM#')"
      >
        ارسال
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-param')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>
  </section>
</template>
<script>
import PreLoaderSpinner from '@core/components/pre-loader-spinner/PreLoaderSpinner.vue'
import {
  BCard, BCardBody, BRow, BCol, BContainer, BFormCheckbox, BButton, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import router from '@/router'
import Device from '@/models/device'
import deviceService from '@/services/device.service'

// eslint-disable-next-line import/no-named-as-default
import Config from '../../../config'
import CustomerService from '@/services/customer.service'
import UserService from '@/services/user.service'
import { getUserData } from '@/auth/utils'
import deviceCommand from '@/mixins/deviceCommand'
import PowerCommandStatus from '@/components/device-command/PowerCommandStatus.vue'

Vue.prototype.$pagesInitializeData.DeviceDashboardVue = {
  firstLoaded: true,
  notificationSettings: {
    ignition: false, charging: false, switchSpeed: false, gpsTracking: false,
  },
}

export default {
  components: {
    PowerCommandStatus,
    BFormInput,
    BFormGroup,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BContainer,
    BFormCheckbox,
    BButton,
    PreLoaderSpinner,
  },
  mixins: [deviceCommand],
  data() {
    return {
      notificationSettings: {
        ignition: false, charging: false, switchSpeed: false, gpsTracking: false,
      },
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      phone: getUserData().mobile,
      phone2: '',
      phone3: '',
      phone4: '',
      second: 20,
      speed: 120,
      devices: [],
      desserts: [],
      address: null,
      devicesOnlineStatus: {},
      selectedDevice: Vue.prototype.$selectDashboard,
      options: Config.carTypes,
      mobileSelectedDevices: this.$mobileSelectedDevices,
      iconCar1: '@/assets/images/icons/car-dash.png',
      iconCar1: '@/assets/images/icons/car-dash.png',
    }
  },
  mounted() {

    /*
    window.addEventListener('resize', () => {
      if (!this.$functions.isMobile()) {
        this.$router.push('/')
      }
    })

     */
  },
  created() {

    // this.selectedDevice = Vue.prototype.$selectDashboard
    // this.doFillDevices()
    // this.checkMobileView(),
    // this.checkSelectedDevices()
  //  this.checkOnlineStatus()
  },
  mutations: {
    onDeleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    doStart() {
      this.selectedDevice = Vue.prototype.$selectDashboard
      this.getServerDeviceStatusAndSettings()
    },
    async getAddress() {
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.address = 'loading'
      try {
        const result = await Vue.prototype.$functions.getFullAddress({
          latitude: coords.lat,
          longitude: coords.lng,
        }, this.selectedDevice)
        this.address = result || 'error'
      } catch (e) {
        this.address = 'error'
      }
    },
    firstLoaded() {
      return Vue.prototype.$pagesInitializeData.DeviceDashboardVue.firstLoaded
    },
    modalSendSms(txt) {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.device.sim}&body=${txt}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.device.sim}?body=${txt}`
        // window.location.href = `http://127.0.0.1:3232/QXNative/?action=openSmsManager&to=${this.device.sim}&body=${encodeURIComponent(txt)}`
      }
    },
    onSendSMS(commandName) {
      if (commandName === 'CENTER') {
        this.$refs['modal-center'].show()
      }
      if (commandName === 'SOS') {
        this.$refs['modal-sosNumber'].show()
      }
      if (commandName === 'SPEED') {
        this.$refs['modal-speed'].show()
      }
      if (commandName === 'RESET') {
        this.$refs['modal-reset'].show()
      }
      if (commandName === 'PARAM') {
        this.$refs['modal-param'].show()
      }
    },
    onSendCommand(imei, commandName) {
      // ارسال و نشان دادنِ نتیجهٔ واقعیِ دستگاه (mixins/deviceCommand)
      this.sendDeviceCommand(imei, commandName)
    },
    getServerDeviceStatusAndSettings() {
      deviceService.getServerDeviceStatusAndSettings({ imei: this.selectedDevice }).then(
          resp => {
            if (resp.status === 'success') {
              if ('result' in resp) {
                const { data } = resp.result
                if (data) {
                  if ('lastStatus' in data) {
                    const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
                    Vue.prototype.$devices[index].serverStatus = data.lastStatus
                  }
                  if ('notificationSettings' in data) {
                    const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
                    Vue.prototype.$devices[index].notificationSettings = data.notificationSettings
                    this.notificationSettings = data.notificationSettings
                  }
                }
                // بخاطر انیمیشن برخی آبجکتها 300 میلی ثانیه صبر میکنیم
                setTimeout(() => {
                  PreLoaderSpinner.methods.hide()
                  Vue.prototype.$pagesInitializeData.DeviceDashboardVue.firstLoaded = false
                }, 300)
              }
            }
          },
      )
    },
    onSetNotificationSettings() {
      const data = {
        imei: this.selectedDevice,
        data: this.notificationSettings,
      }
      deviceService.notificationSettings(data).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: 'تنظیمات هشدار با موفقیت آپدیت شد.',
                icon: 'XIcon',
                variant: 'success',
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    getMarkerImei(index) {
      if (this.selectedImei) {
        return this.selectedImei
      }
      return index
    },
    getDeviceInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(this.getMarkerImei(index)))
    },
    select(option) {
      this.selected = option
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    getDeviceSpeed(imei) {
      if (typeof imei === 'undefined') return false
      if ('speed' in Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)]) {
        return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].speed
      }
      return false
    },
    getDeviceOnlineStatusCssClass(imei) {
      if (typeof imei === 'undefined') return false
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    sinceFrom(unixTime) {
      if (unixTime < 1000) {
        return 'مدتی پیش'
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },

    getLastAlarm(imei) {
      const deviceInfo = this.getDeviceInfo(imei)
      // بررسی وجود اطلاعات
      if (!deviceInfo || !deviceInfo.serverStatus || !deviceInfo.serverStatus.terminalInfo) {
        return 0
      }
      const { gpsTrackingChangeTime = 0, ignitionChangeTime = 0 } = deviceInfo.serverStatus.terminalInfo
      const lastStatus = Vue.prototype.$functions.getStatusMovement(imei)
      if (ignitionChangeTime === 0) {
        if (gpsTrackingChangeTime !== 0) {
          return gpsTrackingChangeTime
        }
      }
      if (lastStatus === 'offline' || lastStatus === 'stop') {
        if (gpsTrackingChangeTime > ignitionChangeTime) return gpsTrackingChangeTime
        return ignitionChangeTime
      }
      return ignitionChangeTime
    },
    checkMobileView() {
      if (!this.$functions.isMobile()) {
        this.$router.push('/')
      }
    },
    async checkSelectedDevices() {
      if (Vue.prototype.$mobileSelectedDevices.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedDevice = Vue.prototype.$mobileSelectedDevices[0]
        const index = Vue.prototype.$functions.getDeviceIndex(this.selectedDevice)
        this.device = Vue.prototype.$devices[index]
        const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.$mobileSelectedDevices[0])
        if (deviceInfo !== null && deviceInfo.serverInfo) {
          const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
          if (coords) {
            this.address = await Vue.prototype.$functions.getFullAddress({
              latitude: coords.lat,
              longitude: coords.lng,
            }, this.selectedDevice)
          }
        }
      }
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
    monitor() {
      router.push({ name: 'home' })
    },
    history() {
      router.push({ name: 'home', params: { action: 'history' } })
    },
    hideModal(id) {
      this.$refs[id].hide()
    },
  },
}
</script>
<style>
#device-dashboard {
  top: 162px !important;
  height: calc( 100vh - 162px ) !important;
  background: #d5d5d5;
}

@media (min-width: 768px) {
  .panel-car{
    width: 80%;
    margin: 0 auto;
    max-width: 700px;
    background: #242632;
    margin-bottom: 30px !important;
    border-radius: 5px;
    padding: 0px 30px;

  }

}
@media (max-width: 767px) {
  #device-dashboard {
    top: 0px !important;
    height: 100vh !important;
  }
  #device-dashboard {
    background-color: #232633;
  }
}

#device-dashboard .card, #device-dashboard .card-body {
  /*background-color: #232633;*/
  border-radius: 0;
}

#device-dashboard .deviceRow {
  margin-bottom: 4px; width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
  /* cursor: pointer;*/
  margin-bottom: 7px;
  background: #444;
  color: #fff;
}
#device-dashboard .deviceRow[selected='selected']{
  background-color: #737574;
}
#device-dashboard .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
#device-dashboard .card-body {
  padding-right: 0.2rem !important;
  padding-left: 0.2rem !important;
}

.onlineSymbol {
  background-color: green;
  border: 1px solid;
}

.offlineSymbol {
  background-color: red;
  border: 1px solid;
}

.v-messages {
  min-height: 0;
}

[dir=rtl] #device-dashboard .addDeviceBtn {
  position: fixed;
  bottom: 60px;
  z-index: 99;
  /*width: 100%;*/
  margin-top: 5px;
}
[dir=rtl] #device-dashboard .card-header{
  padding-bottom: 0;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: #28c76a;
}
[dir] .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: #6bb37a;
  border-color: #fff;
}
[dir] .header-navbar-shadow {
  background: unset !important;
}
.imgcar{
  height:30vh;
}
.imgcartop{
  height: 5vh;
}
</style>
